export const GET_BRANCH_REQUEST = 'GET_BRANCH_REQUEST' as const;
export const GET_BRANCH_SUCCESS = 'GET_BRANCH_SUCCESS' as const;
export const GET_BRANCH_ERROR = 'GET_BRANCH_ERROR' as const;

export const GET_UNIQUE_AAD_REQUEST = 'GET_UNIQUE_AAD_REQUEST' as const;
export const GET_UNIQUE_AAD_SUCCESS = 'GET_UNIQUE_AAD_SUCCESS' as const;
export const GET_UNIQUE_AAD_ERROR = 'GET_UNIQUE_AAD_ERROR' as const;

export const PUT_BRANCH_REQUEST = 'PUT_BRANCH_REQUEST' as const;
export const PUT_BRANCH_SUCCESS = 'PUT_BRANCH_SUCCESS' as const;
export const PUT_BRANCH_ERROR = 'PUT_BRANCH_ERROR' as const;

export const POST_NEW_BRANCH_REQUEST = 'POST_NEW_BRANCH_REQUEST' as const;
export const POST_NEW_BRANCH_SUCCESS = 'POST_NEW_BRANCH_SUCCESS' as const;
export const POST_NEW_BRANCH_ERROR = 'POST_NEW_BRANCH_ERROR' as const;

export const DELETE_BRANCH_REQUEST = 'DELETE_BRANCH_REQUEST' as const;
export const DELETE_BRANCH_SUCCESS = 'DELETE_BRANCH_SUCCESS' as const;
export const DELETE_BRANCH_ERROR = 'DELETE_BRANCH_ERROR' as const;

export const POST_SEND_TEST_MESSAGE_REQUEST = 'POST_SEND_TEST_MESSAGE_REQUEST' as const;
export const POST_SEND_TEST_MESSAGE_SUCCESS = 'POST_SEND_TEST_MESSAGE_SUCCESS' as const;
export const POST_SEND_TEST_MESSAGE_ERROR = 'POST_SEND_TEST_MESSAGE_ERROR' as const;

export const GET_MESSAGE_CAUSE_REQUEST = 'GET_MESSAGE_CAUSE_REQUEST' as const;
export const GET_MESSAGE_CAUSE_SUCCESS = 'GET_MESSAGE_CAUSE_SUCCESS' as const;
export const GET_MESSAGE_CAUSE_ERROR = 'GET_MESSAGE_CAUSE_ERROR' as const;

export const CLEAR_BRANCH_STATE = 'CLEAR_BRANCH_ERROR' as const;

export const FORCE_SAVE_BRANCH_SET = 'FORCE_SAVE_BRANCH_SET' as const;
export const SET_SAVE_BRANCH_SET = 'SET_SAVE_BRANCH_SET' as const;
